import { render, staticRenderFns } from "./ResultF.vue?vue&type=template&id=8545e054&"
import script from "./ResultF.vue?vue&type=script&lang=js&"
export * from "./ResultF.vue?vue&type=script&lang=js&"
import style0 from "./ResultF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports